var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM8 11.5h8m-4 4v-8M22.5 22l-2-2","stroke":"var(--v-grey-darken-1)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }